import { api } from "@/api";
import { useMutation } from "@tanstack/react-query";

export interface CreateDERequest {
    iTiDE: number;
    dEst: string;
    dPunExp: string;
    dFeEmiDE: string;
    dCondTiCam: number;
    receptorId: string;
    obraId?: string;
    clienteId?: string;
    iTipEmi: number;
    cMoneOpe: string;
    dTiCam?: number;
    facturaElectronica?: {
        iIndPres: number;
        dFecEmNR?: string;
    };
    autoFactura?: {
        iNatVen?: number;        // Naturaleza del vendedor (1=Persona Física, 2=Persona Jurídica)
        iTipIDVen?: number;      // Tipo de documento del vendedor
        dNumIDVen?: string;      // Número de documento del vendedor (RUC)
        dNomVen?: string;        // Nombre/Razón social del vendedor
        dEmailVen?: string;      // Email del vendedor (opcional)
        dDirVen?: string;        // Dirección del vendedor
        dNumCasVen?: number;     // Número de casa del vendedor
        cDepVen?: number;        // Código de departamento del vendedor
        cDisVen?: number;        // Código de distrito del vendedor
        cCiuVen?: number;        // Código de ciudad del vendedor
        transaccionAutoFactura?: {
            dDirProv?: string;   // Dirección donde se realiza la transacción
            cDepProv?: number;   // Código de departamento donde se realiza la transacción
            cCiuProv?: number;   // Código de ciudad donde se realiza la transacción
        };
    };
    notaCreditoDebito?: {
        iMotEmi: number;
        dDesMotEmi?: string;
    };
    notaRemision?: {
        iMotEmiNR: number;
        iRespEmiNR: number;
        dKmR: number;
        dFecEm: string;
    };
    transporte?: {
        iTipTrans: number;
        iModTrans: number;
        iRespEmiNR: number;
        dIniTras: string;
        dFinTras: string;
        localSalida: {
            dDirLocSal: string;
            dNumCasSal: number;
            cDepSal: number;
            cCiuSal: number;
        };
        localEntrega: {
            dDirLocEnt: string;
            dNumCasEnt: number;
            cDepEnt: number;
            cCiuEnt: number;
        };
        vehiculo: {
            dTiVehTras: string;
            dMarVeh: string;
            dTipIdenVeh: number;
            dNroIDVeh?: string;
            dNroMatVeh?: string;
        };
        transportista: {
            iNatTrans: number;
            dNomTrans: string;
            dRucTrans?: string;
            dDVTrans?: number;
            iTipIDTrans?: number;
            dNumIDTrans?: string;
            cNacTrans?: string;
            dDesNacTrans?: string;
            dDomFisc?: string;
            dNumIDChof: string;
            dNomChof: string;
            dDirChof?: string;
        };
    };
    condicionPago?: {
        iCondOpe: number;
        listFormaDePago?: Array<{
            iTiPago: number;
            dMonTiPag: number;
            cMoneTiPag?: string;
            dTiCamTiPag?: number;
        }>;
        creditoCondicionPago?: {
            iCondCred: number;
            dPlazoCre?: string;
            dCuotas: number;
            dMonEnt?: number;
        };
    };
    items: Array<{
        dCodInt: string;
        dDesProSer: string;
        cUniMed: number;
        dCantProSer: number;
        dPUniProSer: number;
        dTotBruOpeItem: number;
        dTotOpeItem: number;
        dDescItem?: number;
        dDescGloItem?: number;
        iAfecIVA?: number;
        dPropIVA?: number;
        dTasaIVA?: number;
        dBasGravIVA?: number;
        dLiqIVAItem?: number;
        dBasExe?: number;
    }>;
    documentosAsociados?: Array<{
        iTipDocAso?: number;
        dCdCDERef?: string;
        dNumDocAso?: string;
        dFecEmiDl?: string;
        iTipoDocAso?: number;
    }>;
    dInfAdic?: string;
}

export interface RespuestaDE {
    idDE: string;
    kuDEBase64: string;
    cdc: string;
    docNumDE: string;
}

async function addDocumentoElectronico(request: CreateDERequest): Promise<RespuestaDE> {
    const { data } = await api.post<RespuestaDE>("/de", request);
    return data;
}

export function useAddDocumentoElectronicoMutation() {
    return useMutation({
        mutationFn: addDocumentoElectronico,
    });
}

async function completarDocumentoElectronico(reservadoId: string, request: CreateDERequest): Promise<RespuestaDE> {
    const { data } = await api.post<RespuestaDE>(`/de/${reservadoId}/completar`, request);
    return data;
}

export function useCompletarDocumentoElectronicoMutation(reservadoId: string) {
    return useMutation({
        mutationFn: (request: CreateDERequest) => completarDocumentoElectronico(reservadoId, request),
    });
}
